<template>
  <div class="footer">
    <div class="footer_top">
      <div class="footer_left">
        <div class="footer_logo">
          <img src="@/assets/index/footer_logo.png" alt="">
        </div>
        <div class="footer_phone">
          <div class="footer_phone_logo">
            <img src="@/assets/index/phone.png" alt="">
          </div>
          <div class="footer_phone_text">
            <span>phone</span>
            <span>+86-13528372819</span>
          </div>
        </div>
        <div class="footer_email">
          <div class="footer_email_logo">
            <img src="@/assets/index/email.png" alt="">
          </div>
          <div class="footer_email_text">
            <span>Email</span>
            <span>hi@cyclusstudio.com</span>
          </div>
        </div>
      </div>
      <div class="footer_center">
        <div class="item">
          <ul>
            <li>应急服务</li>
            <li v-for="item in solutionList" :key="item.id" @click="handleClick(item)">{{item.name}}</li>
          </ul>
        </div>
        <div class="item">
          <ul>
            <li>关于我们</li>
            <li @click="handleToClick(item)">企业介绍</li>
          </ul>
        </div>
        <div class="item">
          <ul>
            <li>合作伙伴</li>
          </ul>
        </div>
      </div>
      <div class="footer_right">
        <div class="code">
          <img src="@/assets/index/code.png" alt="">
        </div>
        <div class="footer_right_text">
          <span>扫描进入即时予小程序</span>
        </div>
      </div>
    </div>
    <div class="footer_bot">
      <div class="bot_left">
        <span>Copyright © 2022 Cyclus Studio - All Right Reserved</span>
      </div>
      <div class="bot_right">
        <span>Terms of conditions</span>
        <span>Privacy Policy</span>
      </div>
    </div>
    <!-- <img class="footer_bot_bg" src="@/assets/index/footer_bg.png" alt=""> -->
  </div>
</template>

<script setup>
import { onMounted, ref, computed, watch } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
const router = useRouter()
const store = useStore()

// 从store获取解决方案列表
const solutionList = computed(() => store.getters.getSolutionList)

function handleClick(item){
  window.scrollTo({ top: 0, behavior: 'smooth' });
  store.commit('SET_ACTIVE_MENU', '/solution')
  router.push({ path: '/solutionFin', query: { id: item.id, pid: item.pid } })
}

function handleToClick(item){
  window.scrollTo({ top: 0, behavior: 'smooth' });
  store.commit('SET_ACTIVE_MENU', '/aboutUs')
  router.push({ path: '/aboutUs'})
}

onMounted(() => {
  // 调用接口获取解决方案列表并存储到store
  store.dispatch('fetchSolutionList').then(() => {
    // console.log(solutionList.value, "solutionList.value");
    
  })

  // console.log(solutionList.value);
  
})

</script>

<style lang="scss" scoped>
.footer {
  position: relative;
  width: 100%;
  height: 6.67rem;
  background: #DD4530;
  .footer_top{
    display: flex;
    justify-content: space-between;
    padding: .89rem 3.25rem;
    .footer_left{
      .footer_logo{
        img{
          width: 1.77rem;
          height: 1.44rem;
        }
      }
      .footer_phone{
        display: flex;
        margin: .78rem 0rem .5rem;
        .footer_phone_logo{
          img{
            width: .3rem;
            height: .3rem;
          }
          margin-right: .25rem;
        }
        .footer_phone_text{
          display: flex;
          flex-direction: column;
          span:nth-child(1){
            font-weight: bold;
            font-size: .17rem;
            color: #FFFFFF;
            margin-bottom: .15rem;
          }
          span:nth-child(2){
            font-weight: 500;
            font-size: .15rem;
            color: rgba(255,255,255,0.8);
          }
        }
      }
      .footer_email{
        display: flex;
        .footer_email_logo{
          img{
            width: .3rem;
            height: .3rem;
          }
          margin-right: .25rem;
        }
        .footer_email_text{
          display: flex;
          flex-direction: column;
          span:nth-child(1){
            font-weight: bold;
            font-size: .17rem;
            color: #FFFFFF;
            margin-bottom: .15rem;
          }
          span:nth-child(2){
            font-weight: 500;
            font-size: .15rem;
            color: rgba(255,255,255,0.8);
          }
        }
      }
    }
    .footer_center{
      display: flex;
      margin-top: .59rem;
      .item{
        ul{
          list-style: none;
          li{
            cursor: pointer;
            margin-bottom: .13rem;
            font-weight: 400;
            font-size: .17rem;
            color: rgba(255,255,255,0.8);
            margin-bottom: .31rem;
          }
        }
        ul li:nth-child(1){
          font-weight: 600;
          font-size: .25rem;
          color: #FAFAFA;
          margin-bottom: .39rem;
        }
      }
      .item:nth-child(2){
        margin: 0rem 1.5rem;
      }
    }
    .footer_right{
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: .61rem;
      .code{
        img{
          width: .95rem;
          height: .95rem;
        }
      }
      .footer_right_text{
        margin-top: .31rem;
        span{
          font-weight: 400;
          font-size: .17rem;
          color: rgba(255,255,255,0.8);
        }
      }
    }
  }
  .footer_bot{
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 1.06rem;
    background: #D23923;
    box-sizing: border-box;
    padding: 0rem 1.31rem 0rem 1.86rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 600;
    font-size: .15rem;
    color: rgba(255,255,255,0.5);
    z-index: 20;
    .bot_right{
      span:nth-child(1){
        margin-right: .41rem;
      }
    }
  }
  .footer_bot_bg{
    width: 11.07rem;
    height: 4.9rem;
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: 10;
  }
}

</style>